"use strict";

angular.module("licensure.services").factory("EXSkillOption", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXSkillOption", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getskilloptions: function (skill_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXSkillOption/GetSkillOptions/",  {
                        params: { skill_id: skill_id}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
